import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { RouterLink } from '@angular/router';
import { PDSService } from '../../../services/pds.service';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [
    FooterComponent,
    StaticSearchComponent,
    CommonHeaderComponent,
    RouterLink,
  ],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss',
})
export class AboutUsComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle('About Us | World2Cover Travel Insurance');
    this.metaService.updateTag({
      name: 'description',
      content: `World2Cover is an award-winning travel insurance provider offering cover for singles, couples, families and more, designed to help fit your trip & budget.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'About Us | World2Cover Travel Insurance',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover is an award-winning travel insurance provider offering cover for singles, couples, families and more, designed to help fit your trip & budget.',
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
